"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Server result from a messaging request.
 */
var MessagingResponse = /** @class */ (function () {
    /**
     * Create a new MessagingResponse instance
     *
     * @param responseDataType  the response data type
     * @param data  the the buffer containing the data
     */
    function MessagingResponse(responseDataType, data) {
        this.responseDataType = responseDataType;
        this.data = data;
    }
    return MessagingResponse;
}());
exports.MessagingResponse = MessagingResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/messaging-response.js
// module id = 1272
// module chunks = 1